(function () {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const flows = new Map();
  const money = cents => window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);

  function columnStop(height, viewportHeight, topInset) {
    return Math.min(topInset, viewportHeight - height - 24);
  }

  function initializeFlow(section) {
    if (flows.has(section)) return;
    const columns = section.querySelector('[data-xr-product-columns]');
    const bar = document.querySelector('[data-xr-sticky-purchase][data-product-section="' + section.id + '"]');
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!columns || !bar || !form) return;
    const buy = form.querySelector('[data-add-to-cart]');
    const action = bar.querySelector('[data-xr-sticky-submit]');
    if (!buy) return;
    // Keep the fixed control outside section animation and overflow contexts.
    document.body.appendChild(bar);
    let active = false;
    let frame = 0;
    let observedChat = null;
    const chatObserver = new MutationObserver(updateVisibility);
    const mainPrice = section.querySelector('[data-product-price]');
    function measure() {
      frame = 0;
      const header = document.querySelector('#SiteHeader');
      const headerRect = header && header.getBoundingClientRect();
      const headerInset = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? headerRect.bottom + 16 : 24;
      columns.querySelectorAll('[data-xr-product-column]').forEach(column => {
        column.style.setProperty('--xr-column-stop', columnStop(column.offsetHeight, window.innerHeight, headerInset) + 'px');
      });
      updateVisibility();
    }
    function updateVisibility() {
      const chat = document.querySelector('shopify-chat');
      if (chat && chat.shadowRoot && chat !== observedChat) {
        chatObserver.observe(chat.shadowRoot, {attributes:true, attributeFilter:['aria-expanded'], subtree:true});
        observedChat = chat;
      }
      const pastProduct = columns.getBoundingClientRect().bottom <= 0;
      const blocked = document.documentElement.classList.contains('js-drawer-open') ||
        document.documentElement.classList.contains('modal-open') || document.documentElement.classList.contains('xrival-lock') ||
        !!document.querySelector('dialog[open], .modal--is-active, .pswp--open') ||
        !!(chat && chat.shadowRoot && chat.shadowRoot.querySelector('[aria-label="Chat"][aria-expanded="true"]'));
      active = pastProduct && !blocked;
      bar.hidden = !active;
      document.body.classList.toggle('xr-sticky-active', active);
      sync();
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }
    function sync() {
      action.disabled = buy.disabled || buy.classList.contains('btn--loading');
      action.classList.toggle('btn--loading', buy.classList.contains('btn--loading'));
      action.textContent = (buy.querySelector('[data-add-to-cart-text]') || buy).textContent.trim();
      if (mainPrice) bar.querySelector('[data-xr-sticky-price]').textContent = mainPrice.textContent.trim();
    }
    action.addEventListener('click', () => {
      if (buy.disabled || buy.classList.contains('btn--loading')) return;
      // Submit the same native product form: variant, properties, plan and selected add-ons remain intact.
      buy.click();
      sync();
    });
    section.addEventListener('variantChange', event => {
      const variant = event.detail && event.detail.variant;
      bar.querySelector('[data-xr-sticky-variant]').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      schedule();
    });
    const observer = new ResizeObserver(schedule);
    columns.querySelectorAll('[data-xr-product-column]').forEach(column => observer.observe(column));
    const buttonObserver = new MutationObserver(sync);
    buttonObserver.observe(buy, {attributes: true, childList: true, subtree: true});
    if (mainPrice) buttonObserver.observe(mainPrice, {childList: true, subtree: true});
    const overlayObserver = new MutationObserver(updateVisibility);
    overlayObserver.observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('drawerOpen', updateVisibility);
    document.addEventListener('drawerClose', schedule);
    document.addEventListener('modalOpen', updateVisibility);
    document.addEventListener('modalClose', schedule);
    section.addEventListener('xr:configurationChange', schedule);
    desktop.addEventListener('change', schedule);
    flows.set(section, {schedule, destroy() {
      observer.disconnect(); buttonObserver.disconnect(); overlayObserver.disconnect(); chatObserver.disconnect(); cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
      document.removeEventListener('drawerOpen', updateVisibility); document.removeEventListener('drawerClose', schedule);
      document.removeEventListener('modalOpen', updateVisibility); document.removeEventListener('modalClose', schedule);
      section.removeEventListener('xr:configurationChange', schedule);
      desktop.removeEventListener('change', schedule); bar.remove(); flows.delete(section);
      document.body.classList.remove('xr-sticky-active');
    }});
    schedule();
  }

  function cartFeedback(event) {
    const detail = event.detail;
    if (!detail || !detail.form) return;
    const form = detail.form;
    const count = detail.count;
    document.querySelectorAll('[data-xr-cart-count]').forEach(el => { el.textContent = count; });
    form.querySelectorAll('[data-xr-checkout-total]').forEach(el => { el.innerHTML = money(detail.subtotal); });
    const status = form.querySelector('[data-xr-cart-status]');
    if (status) status.textContent = count ? 'Cart updated. ' + count + (count === 1 ? ' item.' : ' items.') : 'Your cart is empty.';
    const viewport = form.querySelector('.drawer__scrollable');
    if (viewport) viewport.classList.remove('xr-cart-refresh');
    if (viewport && !reducedMotion.matches) requestAnimationFrame(() => viewport.classList.add('xr-cart-refresh'));
  }

  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-xr-cart-remove]');
    if (!remove) return;
    const form = remove.closest('form[data-location]');
    const item = remove.closest('.cart__item');
    if (!form || !item || !window.theme || !window.theme.CartForm) return;
    event.preventDefault();
    if (form.dataset.xrCartBusy === 'true') return;
    document.dispatchEvent(new CustomEvent('cart:quantity.cart-' + form.dataset.location, {
      detail: [item.dataset.key, 0, item.querySelector('.js-qty__wrapper')]
    }));
  });
  document.addEventListener('cart:rendered', cartFeedback);
  function initialize(root) {
    root.querySelectorAll('[data-xr-product-flow]').forEach(initializeFlow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    flows.forEach((flow, section) => { if (event.target.contains(section)) flow.destroy(); });
  });
  window.xrShoppingFlow = {columnStop};
})();
